import { Injectable } from '@angular/core';
import {environment} from '../../environment/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientServiceService {

  baseurl = environment.api_client_service;

  client_form_emails: any = null;
  is_form_visible: boolean = false;
  existing_form_email: string = "";

  is_creation_form_pending: boolean = false;

  constructor(private http: HttpClient) { }

  get_customer_info(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })
    return this.http.get(this.baseurl + '/client/details', {headers});
  }

  get_auth_form_by_email(token: string, email: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })
    return this.http.get(this.baseurl + `/client/authorizat-form?email=${email}`, {headers});
  }

  delete_auth_form(token: string, auth_form_id: number): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })

    return this.http.delete(this.baseurl + `/client/authorizat-form/${auth_form_id}/delete`, {headers});
  }

  delete_child_form(token: string, child_customer_id: number): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })

    return this.http.post(this.baseurl + `/client/remove-children/${child_customer_id}`, {}, {headers});
  }

  get_dashboard(token: string, email: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })
    return this.http.get(this.baseurl + `/client/dashboard-by-email?email=${email}`, {headers});
  }

  get_timelines(token: string, email: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })
    return this.http.get(this.baseurl + `/client/timeline-by-email?email=${email}`, {headers});
  }

  get_client_profile(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })
    return this.http.get(this.baseurl + '/client/authorizat-forms', {headers});
  }

  get_client_forms(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })
    return this.http.get(this.baseurl + '/client/authorizat-forms', {headers});
  }

  create_authorizat_form(token: string, data: FormData) {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })
    return this.http.post(this.baseurl + '/client/authorizat-forms', data, {headers});
  }

  download_profile_pdf(token: string, email: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })
    return this.http.get(this.baseurl + `/client/authorizat-form/download-agreement?email=${email}`, {headers, responseType: 'blob'});
  }

  invite_customer(token: string, email: string){
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })
    const payload = {
      emails: [email]
    }
    return this.http.post(this.baseurl + '/client/add-children', payload, {headers});
  }

  check_possibility_filling(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })
    return this.http.get(this.baseurl + '/client/check-filling-possibility', {headers});
  }

  get_plans(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `bearer ${token}`,
    })
    return this.http.get(this.baseurl + '/client/plans', {headers});
  }

  get_blogs(page: number, size: number): Observable<any> {
    return this.http.get(this.baseurl + `/client/posts/?page=${page}&size=${size}`);
  }

  get_blog_info(blog_url: string): Observable<any> {
    return this.http.get(this.baseurl + `/client/posts/${blog_url}`);
  }

  set_client_form_emails(emails: any) {
    this.client_form_emails = emails;
  }

  get_client_form_emails() {
    return this.client_form_emails;
  }

  set_is_form_visible(value: boolean) {
    this.is_form_visible = value;
  }

  get_is_form_visible() {
    return this.is_form_visible;
  }
}